import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Option} from '../../back-office/Models/Option';
import {Helper} from '../../helpers/helper.service';
import * as _ from 'lodash';
import {NgForm} from '@angular/forms';
import {OrderItemProduct} from '../../back-office/Models/OrderItemProduct';
import {BehaviorSubject} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

export interface OptionItem {
  option: Option;
  children: any;
  first: boolean;
  optionSelected?: number;
  parent: number;
  products: any;
  firstParent: number;
}

export interface ResponseItem {
  i: any;
  j: any
}

@Component({
  selector: 'app-option',
  templateUrl: './option.component.html',
  styleUrls: ['./option.component.scss']
})
export class OptionComponent implements OnInit, AfterViewInit {
  @Input() show: any;
  @Input() optionItems: any;
  public options: Option;
  @Input() orderItemIndex: number;
  @Input() optionProductIndex: number;
  @Input() lastValues: Option[];
  @Input() orderItemProducts: OrderItemProduct[];
  @Input() parentFormChecked?: boolean;
  @Output() orderItemProductOption = new EventEmitter<any>();
  @Output() checkIsValid = new EventEmitter<any>();
  public localOptions: OptionItem[] = [];
  public optionItem: number;
  public optionFields = [];
  public indentNumber = 0;
  public products = [];
  public firstOptionSelected = false;
  public firstParent: number;
  public isEdit = false;
  @ViewChild('optionForm', {static: false}) optionForm: NgForm;
  public changeItem = true;
  options$: BehaviorSubject<any>;

  constructor(private translate: TranslateService, private helper: Helper) {
    this.options$ = new BehaviorSubject(null);
  }

  ngAfterViewInit(): void {
    if (Helper.isDefined(this.optionForm)) {
      this.optionForm.statusChanges.subscribe(
        result => {
          this.checkIsValid.emit({
            index: this.optionProductIndex,
            status: (result == 'INVALID') ? false : true,
            product: this.optionItems.product.id,
            orderItem: this.orderItemIndex
          });
        }
      );
    }
  }

  ngOnInit() {
    this.options = this.optionItems.option;
    this.firstParent = this.options.id;
    if (this.options.options.length > 0) {
      this.localOptions.push({
        option: this.options,
        children: this.options.options,
        first: true,
        parent: 0,
        products: this.optionItems.products,
        firstParent: this.firstParent
      });
      this.optionFields = [this.localOptions];
      if (this.lastValues.length > 0) {
        this.isEdit = true;
        this.splitLastValue();
        _.remove(this.lastValues, (value) => value.firstParent != this.firstParent);
      }
      this.orderItemProductOption.emit({
        mainOption: this.optionFields,
        orderItem: this.orderItemIndex,
        formIsValid: (Helper.isDefined(this.optionForm)) ? this.optionForm.valid : false,
        show: true
      });
    }
  }

  splitLastValue() {
    this.optionFields = JSON.parse(JSON.stringify(this.optionFields));
    let fabric = false;
    let AsFabricCollection = false;
    let AsFabric = false;
    let AsFabricColor = false;
    this.optionFields.forEach((field, i) => {
      field.forEach((optionLocal, j) => {
        if (!Helper.isDefined(optionLocal['optionSelected'])) {
          const lastValueIndex = _.findIndex(this.lastValues, (value) => _.find(optionLocal.children, (child) => {
              fabric = (Helper.isDefined(child.fabricCollections) && child.fabricCollections.length > 0);
              if (optionLocal.AsFabricCollection && value.fabric) {
                AsFabricCollection = true;
                const fabricItem = JSON.parse(JSON.stringify(value.fabric));
                return child.id == fabricItem.fabricCollection.id && optionLocal.parent == value.urbanOption.id;
              } else if (optionLocal.AsFabric && value.fabric) {
                AsFabric = true;
                const fabricObj = JSON.parse(JSON.stringify(value.fabric));
                return child.id == fabricObj.id;
              } else if (optionLocal.AsFabricColor && value.fabricColor) {
                AsFabricColor = true;
                const fabricColor = JSON.parse(JSON.stringify(value.fabricColor));
                return child.id == fabricColor.id;
              } else {
                AsFabricCollection = false;
                AsFabric = false;
                AsFabricColor = false;
                return child.id == value.urbanOption.id;
              }

            }));
          if (lastValueIndex > -1) {
            if (AsFabricCollection) {
              optionLocal['optionSelected'] = this.lastValues[lastValueIndex].fabric['fabricCollection'].id;
            } else if (AsFabric) {
              optionLocal['optionSelected'] = this.lastValues[lastValueIndex].fabric['id'];
            } else if (AsFabricColor) {
              optionLocal['optionSelected'] = this.lastValues[lastValueIndex].fabricColor['id'];
            } else {
              optionLocal['optionSelected'] = this.lastValues[lastValueIndex].urbanOption.id;
            }
            if (!fabric && !AsFabricCollection && !AsFabric) {
              this.lastValues.splice(lastValueIndex, 1);
            }
            AsFabricCollection = false;
            AsFabric = false;
            AsFabricColor = false;
            this.addViewOption(optionLocal['optionSelected'], i, j, optionLocal, this.orderItemIndex, field);
          }
        }
      });
    });

  }

  addViewOption(option, i, j, optionLocal, orderItemIndex, field) {
    new Promise((resolve, reject) => {
      this.onRevercedOptions(option, i, j, optionLocal, orderItemIndex, field);
      resolve([true]);
    }).then((resp) => {
      this.splitLastValue();
    });
  }

  onRevercedOptions(option, i, j, optionLocal, orderItemIndex, field) {
    let optionItem: Option = new Option();// Create option and fill with selected option values
    let products = field[0].products;
    optionItem = optionLocal.children[optionLocal.children.findIndex((x) => x.id === option)]; // find children option by option ID
    if (Helper.isDefined(optionItem)) {
      if (optionItem.type == Option.OPTION_TYPE_OPTION && Helper.isDefined(this.optionFields[i + 1]) && this.optionFields[i + 1][0].AsFabricCollection == true && this.optionFields[i + 1].parent != optionItem.id) {
        this.indentNumber = this.indentNumber - 2;
        this.optionFields.splice(i + 1, 1);
        this.optionFields = JSON.parse(JSON.stringify(this.optionFields));
      }
      const selectedOptions = Object.assign([], this.optionFields);

      //  When we change option,
      // We must cleared the last value of child options
      // if (i === 0 && Helper.isDefined(this.optionFields[i][j + 1])) {
      //   this.optionFields[i].splice(j + 1, 3);
      // }
      // this.convertFabricOptionToOption(this.optionFields);
      selectedOptions.forEach((local, localIndex) => {
        local.forEach((item, itemIndex) => {
          if (item.hasOwnProperty('AsFabricCollection')) {
            selectedOptions[localIndex][itemIndex].fabricCollection = item.optionSelected;
          }
          if (item.hasOwnProperty('AsFabric')) {
            selectedOptions[localIndex][itemIndex - 1].fabric = item.optionSelected;
          }
          if (item.hasOwnProperty('AsFabricColor')) {
            selectedOptions[localIndex][itemIndex - 2].fabricColor = item.optionSelected;
          }
        });
      });
      this.orderItemProductOption.emit({
        mainOption: selectedOptions,
        orderItem: orderItemIndex,
        formIsValid: (Helper.isDefined(this.optionForm)) ? this.optionForm.valid : true,
        show: false,
        firstParent: this.firstParent
      });
      /*
      // When this condition enable sub options of type select not show correctly
      if (Helper.isDefined(j)) {
        this.optionFields[i].splice(j + 2, this.optionFields[i].length);
        this.optionFields.splice(i + 1, this.optionFields.length);
      }*/
      // check if current option item has option child and option type is not select
      // then check if total child options of this option more than 0
      // check if first child options type not SELECT
      if (Helper.isDefined(optionItem.options) && optionItem.type !== Option.OPTION_TYPE_SELECT &&
        optionItem.options.length > 0 && optionItem.options[0].type === Option.OPTION_TYPE_OPTION) {
        if (optionItem.options.length > 0) {
          if (!Helper.isDefined(this.optionFields[i][j].optionSelected)) {
            this.optionFields[i][j].optionSelected = optionItem.id;
          }
          this.optionFields[i][1 + j] = {
            option: optionItem,
            children: optionItem.options,
            first: false,
            parent: optionItem.id,
            products: products,
            firstParent: this.firstParent
          };
        }
      }
      // Use this if for type fabric and its children
      else if (optionItem.type == Option.OPTION_TYPE_FABRIC && optionItem.fabricCollections.length > 0) {
        const selectedOptionsItem = Object.assign([], this.optionFields[parseInt(i) + 1]);
        const selectedOptionsItem2 = Object.assign([], this.optionFields[parseInt(i)]);
        if ((Helper.isDefined(selectedOptionsItem[0]) && !selectedOptionsItem[0].AsFabricCollection)
          || (Helper.isDefined(selectedOptionsItem[1]) && !selectedOptionsItem[1].AsFabricCollection)
          || selectedOptionsItem2[0])
        {
          const newFabricOption = {
            option: optionItem,
            children: optionItem.fabricCollections,
            first: false,
            parent: optionItem.id,
            AsFabricCollection: true,
            products: products,
            firstParent: this.firstParent,
            status: optionItem.status,
            deleted: optionItem.deleted,
            indentNumber: 0
          };
          this.optionFields.splice(i + 1, 0, [newFabricOption]);
          this.optionFields[parseInt(i) + 1][0].indentNumber = (this.optionFields[parseInt(i)][0].indentNumber ? this.optionFields[parseInt(i)][0].indentNumber : 0) + 1;
          this.optionFields = JSON.parse(JSON.stringify(this.optionFields));
          this.options$.next(false);
          this.options$.next(true);
        }
        this.indentNumber++;
      }
      // Use this if option type is fabric
      else if (!Helper.isDefined(optionItem.type) && Helper.isDefined(optionItem.fabrics) && optionItem.fabrics.length > 0) {
        this.optionFields[i][j + 1] = {
          option: optionItem,
          children: optionItem.fabrics,
          first: false,
          parent: optionItem.id,
          products: products,
          AsFabric: true,
          firstParent: this.firstParent,
          status: optionItem.status,
          deleted: optionItem.deleted
        };
      }
      // This if use for lastest fabric option loading
      else if (!Helper.isDefined(optionItem.type) && Helper.isDefined(optionItem.fabricColors) && optionItem.fabricColors.length > 0) {
        this.optionFields[i][j + 1] = {
          option: optionItem,
          children: optionItem.fabricColors,
          first: false,
          parent: optionItem.id,
          products: products,
          AsFabricColor: true,
          firstParent: this.firstParent,
          status: optionItem.status,
          deleted: optionItem.deleted
        };
      }
      // Other type of options
      else {
        if (Helper.isDefined(optionItem.options) && optionItem.options.length === 0 && !Helper.isDefined(this.optionFields[i][0].optionSelected)) {
          this.optionFields[i][0].optionSelected = optionItem.id;
        }
        if ((Helper.isDefined(optionItem.options) && optionItem.options.length > 0)) {
          for (let m = 0; m < optionItem.options.length; m++) {
            this.optionFields.splice(i + 1 + m, 0, [{
              option: optionItem.options[m],
              children: (optionItem.options[m].options.length) ? optionItem.options[m].options : optionItem.options[m].fabricCollections,
              first: false,
              products: products,
              parent: optionItem.id,
              firstParent: this.firstParent,
              indentNumber: 0
            }]);
            this.optionFields[i + 1 + m][0].indentNumber = this.optionFields[i + 1 + m][0].indentNumber + 1;
            this.optionFields = JSON.parse(JSON.stringify(this.optionFields));
            this.options$.next(false);
            this.options$.next(true);
            if (m > 0) {
              this.indentNumber++;
            }
          }
          let chnageTemp = [];
          for (let i in this.optionFields) {
            chnageTemp.push((this.optionFields[i]));
          }
          this.optionFields = chnageTemp;

        }
        if (Helper.isDefined(optionItem.fabrics) && optionItem.fabrics.length > 0) {
          for (let m = 0; m < optionItem.fabrics.length; m++) {
            this.optionFields[i + 1 + m] = [{
              option: optionItem.fabrics[m],
              children: optionItem.fabrics[m].fabricColors,
              first: false,
              products: products,
              parent: optionItem.fabrics[m].id,
              firstParent: this.firstParent
            }];
          }
        }
      }
      this.optionFields.forEach(optionField => {
        if (!Helper.isDefined(optionField.optionSelected) && optionItem.type === Option.OPTION_TYPE_OPTION) {
          this.optionFields[i][j].optionSelected = optionItem.id;
        }
      });
    }
    this.sortAndUniqueOptionFields();
  }

  sortAndUniqueOptionFields() {
    this.optionFields = _.uniqBy(this.optionFields, optionField => optionField[0].option.id);
    this.optionFields.forEach((optionFieldList, index) => {
      if (Helper.isDefined(optionFieldList[0].parent) && optionFieldList[0].AsFabricCollection) {
        const fabricOptionParentId = optionFieldList[0].parent;
        const parentIndex = _.findIndex(this.optionFields, optionFieldArray => {
          const result =  optionFieldArray[0].children.findIndex(childOption => childOption.id === fabricOptionParentId);
          return result > -1;
        });
        if (index !== parentIndex + 1) {
          this.optionFields.splice(index, 1);
          this.optionFields.splice(parentIndex + 1, 0, optionFieldList);
        }
      }
    });
  }

  checkOption(items, j = 0, z = 0) {

    for (let item in items) {
      if (items.hasOwnProperty(item)) {
        let element = (_.isArrayLike(items[item])) ? items[parseInt(item)][0] : items[item];
        const selectedOptions034 = Object.assign([], element);
        if (!Helper.isDefined(element.optionSelected)) {
          element.children.forEach((child) => {

            this.lastValues.forEach((value) => {
              let valueCopy = JSON.parse(JSON.stringify(value));
              if ((value.urbanOption.id == child.id) ||
                ((Helper.isDefined(element.AsFabricCollection) && valueCopy.fabric && valueCopy.fabric.fabricCollection.id == child.id))) {


                element.optionSelected = child.id;

                new Promise((resolve, reject) => {
                  let tempi = (Helper.isDefined(this.optionFields[item])) ? item : 0;
                  let tempJ = 0;

                  const selectedOptions01 = Object.assign([], this.optionFields);
                  if (Helper.isDefined(element.AsFabricCollection)) {
                    for (let z in selectedOptions01) {
                      for (let j in selectedOptions01[z]) {
                        if (selectedOptions01[z][j].option.id == valueCopy.urbanOption.id && (selectedOptions01[z][j].products.indexOf(valueCopy.product.id) > -1)) {
                          tempi = parseInt(z);
                          tempJ = parseInt(j);
                        }
                      }
                    }
                  }
                  this.onShowChildOptions(element.optionSelected, tempi, tempJ, element, this.orderItemIndex, [element]);
                  resolve([true]);

                }).then((resp) => {
                  if ((Helper.isDefined(items[item]) && items[item].length > 0) || (Helper.isDefined(element.AsFabricCollection)) || (Helper.isDefined(element.AsFabric))) {
                    if (Helper.isDefined(element.AsFabricCollection)) {
                      let elementi = (_.isArrayLike(items[item])) ? items[parseInt(item)][1] : items[parseInt(item)][1];
                      if (!Helper.isDefined(elementi)) {
                        elementi = items[parseInt(item)];
                      }
                      const selectedOptionsx = Object.assign([], this.optionFields);
                      elementi.children.forEach((child) => {
                        this.lastValues.forEach((value) => {
                          let valueCopyFabric = JSON.parse(JSON.stringify(value));
                          if (Helper.isDefined(elementi.AsFabric) && value.fabric && value.fabric['id'] == child.id) {
                            elementi.optionSelected = child.id;
                            new Promise((resolve, reject) => {
                              let tempii = (Helper.isDefined(this.optionFields[item])) ? item : 0;
                              let tempJi = (Helper.isDefined(this.optionFields[tempii][0])) ? j + 2 : 0;
                              for (let z in selectedOptionsx) {
                                for (let j in selectedOptionsx[z]) {
                                  if (selectedOptionsx[z][j].option.id == valueCopy.urbanOption.id && (selectedOptionsx[z][j].products.indexOf(valueCopy.product.id)) > -1) {
                                    tempii = parseInt(z);
                                    tempJi = parseInt(j) + 1;
                                  }
                                }
                              }
                              this.onShowChildOptions(elementi.optionSelected, tempii, tempJi, elementi, this.orderItemIndex, [elementi]);
                              resolve([tempii, tempJi]);
                            }).then((resp: Response) => {
                              let elementiz = items[parseInt(item)][2];
                              if (!Helper.isDefined(elementiz)) {
                                elementiz = _.find(items, function (o) {
                                  return (o.AsFabric);
                                });
                              }
                              elementiz.children.forEach((child) => {
                                this.lastValues.forEach((value) => {
                                  if (Helper.isDefined(elementiz.AsFabricColor) && value.fabricColor && value.fabricColor['id'] == child.id) {
                                    elementiz.optionSelected = child.id;
                                    this.onShowChildOptions(elementiz.optionSelected, resp[0], resp[1] + 1, elementiz, this.orderItemIndex, [elementiz]);
                                  }
                                });
                              });

                            });
                          }
                        });
                      });
                    } else if (Helper.isDefined(element.AsFabric)) {
                      j = j + 2;
                    } else {
                      this.checkOption(items[parseInt(item)], 0, 0);
                    }
                  }
                });
              }
            });
          });
        }
      }
    }
  }


  /**
   * This function calls on option value changes
   *
   * @param option  id of current option selected
   * @param i  number of sub option level
   * @param j
   * @param optionLocal value of current changed value option
   * @param orderItemIndex
   * @param field
   */
  onShowChildOptions(option, i, j, optionLocal, orderItemIndex, field) {
    // if (i == 0 && Helper.isDefined(this.optionFields) && this.optionFields.length > 0) {
    //   this.optionFields.splice(1, this.optionFields.length);
    // }
    let optionItem: Option = new Option();// Create option and fill with selected option values
    let products = field[0].products;
    optionItem = optionLocal.children[optionLocal.children.findIndex((x) => x.id === option)]; // find children option by option ID

    const selectedOptions = Object.assign([], this.optionFields);
    //  When we change option,
    // We must cleared the last value of child options
    // if (i === 0 && Helper.isDefined(this.optionFields[i][j + 1])) {
    //   this.optionFields[i].splice(j + 1, 3);
    // }

    // this.convertFabricOptionToOption(this.optionFields);
    selectedOptions.forEach((local, localIndex) => {
      local.forEach((item, itemIndex) => {
        if (item.hasOwnProperty('AsFabricCollection')) {
          selectedOptions[localIndex][itemIndex].fabricCollection = item.optionSelected;
        }
        if (item.hasOwnProperty('AsFabric')) {
          selectedOptions[localIndex][itemIndex - 1].fabric = item.optionSelected;
        }
        if (item.hasOwnProperty('AsFabricColor')) {
          selectedOptions[localIndex][itemIndex - 2].fabricColor = item.optionSelected;
        }
      });
    });
    this.orderItemProductOption.emit({
      mainOption: selectedOptions,
      orderItem: orderItemIndex,
      formIsValid: (Helper.isDefined(this.optionForm)) ? this.optionForm.valid : true,
      show: true,
      firstParent: this.firstParent
    });
    /*
    // When this condition enable sub options of type select not show correctly
    if (Helper.isDefined(j)) {
      this.optionFields[i].splice(j + 2, this.optionFields[i].length);
      this.optionFields.splice(i + 1, this.optionFields.length);
    }*/
    // check if current option item has option child and option type is not select
    // then check if total child options of this option more than 0
    // check if first child options type not SELECT
    if (Helper.isDefined(optionItem.options) && optionItem.type !== Option.OPTION_TYPE_SELECT &&
      optionItem.options.length > 0 && optionItem.options[0].type == Option.OPTION_TYPE_OPTION) {
      if (optionItem.options.length > 0) {
        this.optionFields[i][1 + j] = {
          option: optionItem,
          children: optionItem.options,
          first: false,
          parent: optionItem.id,
          products: products,
          firstParent: this.firstParent
        };
      }
    }
    // Use this if for type fabric and its children
    else if (optionItem.type == Option.OPTION_TYPE_FABRIC && optionItem.fabricCollections.length > 0) {
      const optionItem1 = Object.assign([], optionItem);
      const selecte = Object.assign([], this.optionFields);
      const selectedOptionsItem = Object.assign([], this.optionFields[parseInt(i) + 1]);
      const selectedOptionsItem2 = Object.assign([], this.optionFields[parseInt(i)]);
      if (Helper.isDefined(selectedOptionsItem) && selectedOptionsItem.length > 0) {
        if (!selectedOptionsItem[0].AsFabricCollection || (Helper.isDefined(selectedOptionsItem[1]) && !selectedOptionsItem[1].AsFabricCollection) || selectedOptionsItem2[0]) {
          this.optionFields[parseInt(i) + 1] = [{
            option: optionItem,
            children: optionItem.fabricCollections,
            first: false,
            parent: optionItem.id,
            AsFabricCollection: true,
            products: products,
            firstParent: this.firstParent,
            status: optionItem.status,
            deleted: optionItem.deleted
          }];
        }
        this.indentNumber++;
        if (Helper.isDefined(selectedOptionsItem) && !selectedOptionsItem[0].AsFabricCollection) {
          this.checkOption(selectedOptionsItem, 0, 0);
          this.optionFields[parseInt(i) + 2] = selectedOptionsItem;
          const selecte3 = Object.assign([], this.optionFields);
        }
      } else if (!Helper.isDefined(selectedOptionsItem2[0].AsFabricCollection)) {
        this.optionFields[parseInt(i) + 1] = [{
          option: optionItem,
          children: optionItem.fabricCollections,
          first: false,
          parent: optionItem.id,
          AsFabricCollection: true,
          products: products,
          firstParent: this.firstParent,
          status: optionItem.status,
          deleted: optionItem.deleted
        }];
        const selectedOptionsItemasl = Object.assign([], this.optionFields);
        this.checkOption(selectedOptionsItemasl, 0, 1);
      }
    }
    // Use this if option type is fabric
    else if (!Helper.isDefined(optionItem.type) && Helper.isDefined(optionItem.fabrics) && optionItem.fabrics.length > 0) {
      if (!Helper.isDefined(this.optionFields[parseInt(i)][parseInt(j) + 1])) {
        this.optionFields[parseInt(i)][parseInt(j) + 1] = {
          option: optionItem,
          children: optionItem.fabrics,
          first: false,
          parent: optionItem.id,
          products: products,
          AsFabric: true,
          firstParent: this.firstParent,
          status: optionItem.status,
          deleted: optionItem.deleted
        };
      }


      const selectedOptionsx2 = Object.assign([], this.optionFields);
    }
    // This if use for lastest fabric option loading
    else if (!Helper.isDefined(optionItem.type) && Helper.isDefined(optionItem.fabricColors) && optionItem.fabricColors.length > 0) {
      if (Helper.isDefined(this.optionFields[i][j]) && this.optionFields[i][j].AsFabric) {
        this.optionFields[i][j + 1] = {
          option: optionItem,
          children: optionItem.fabricColors,
          first: false,
          parent: optionItem.id,
          products: products,
          AsFabricColor: true,
          firstParent: this.firstParent,
          status: optionItem.status,
          deleted: optionItem.deleted
        };
      }
    }
    // Other type of options
    else {
      if ((Helper.isDefined(optionItem.options) && optionItem.options.length > 0)) {
        for (let m = 0; m < optionItem.options.length; m++) {
          this.optionFields[i + 1 + m] = [{
            option: optionItem.options[m],
            children: (optionItem.options[m].options.length) ? optionItem.options[m].options : optionItem.options[m].fabricCollections,
            first: false,
            products: products,
            parent: optionItem.id,
            firstParent: this.firstParent
          }];
          // we use this for
          if (m > 0) {
            this.indentNumber++;
          }
        }
        let chnageTemp = [];
        for (let i in this.optionFields) {
          chnageTemp.push((this.optionFields[i]));
        }
        this.optionFields = chnageTemp;

      }
      if (Helper.isDefined(optionItem.fabrics) && optionItem.fabrics.length > 0) {
        for (let m = 0; m < optionItem.fabrics.length; m++) {
          this.optionFields[i + 1 + m] = [{
            option: optionItem.fabrics[m],
            children: optionItem.fabrics[m].fabricColors,
            first: false,
            products: products,
            parent: optionItem.fabrics[m].id,
            firstParent: this.firstParent
          }];
        }
      }
    }
  }

  /**
   * This function calls on option value changes
   *
   * @param option  id of current option selected
   * @param i  number of sub option level
   * @param j
   * @param optionLocal value of current changed value option
   * @param orderItemIndex
   * @param field
   */
  onChangeChildOptions(option, i, j, optionLocal, orderItemIndex, field) {
    // if (i == 0 && Helper.isDefined(this.optionFields) && this.optionFields.length > 0) {
    //   this.optionFields.splice(1, this.optionFields.length);
    // }
    if (optionLocal.parent == 0) {
      this.indentNumber = 0;
      this.optionFields.splice(i + 1, this.optionFields.length - 1);
      this.optionFields[i].splice(j + 1, this.optionFields[j].length);
    } else {
      if (Helper.isDefined(this.optionFields[i + 1])) {
        let parentIndex = _.findIndex(optionLocal.children, (o: Option) => o.id == this.optionFields[i + 1][0].parent && Helper.isDefined(o.fabricColors) && o.fabricColors.length == 0);
        if (parentIndex > -1) {
          this.optionFields.splice(i + 1, 1);
        }
      }
      this.optionFields[i].splice(j + 1, this.optionFields[i].length - 1);
    }
    let optionItem: Option = new Option();// Create option and fill with selected option values
    let products = field[0].products;
    optionItem = optionLocal.children[optionLocal.children.findIndex((x) => x.id === option)]; // find children option by option ID
    if (!Helper.isDefined(optionItem)) {
      // option was cleared (D23: carpet Shape/Finishing/Colour dropdowns are now clearable) -
      // still notify the parent so price/summary recompute with this option removed
      this.emitOptionCleared(orderItemIndex);
      return;
    }
    if (Helper.isDefined(optionItem)) {
      if (optionLocal.AsFabricCollection === true) {
        if (optionItem.discounted) {
          this.helper.popMessageDialog(
            this.translate.instant('global.fabric_collection.descounted_alert.title'),
            this.translate.instant('global.fabric_collection.descounted_alert.message'),
            'warning', false
          );
        }
      }
      if (optionItem.type == Option.OPTION_TYPE_OPTION && Helper.isDefined(this.optionFields[i + 1]) && this.optionFields[i + 1][0].AsFabricCollection == true && this.optionFields[i + 1].parent != optionItem.id) {
        this.indentNumber = this.indentNumber - 2;
        this.optionFields.splice(i + 1, 1);
        this.optionFields = JSON.parse(JSON.stringify(this.optionFields));
      }
      const selectedOptions = Object.assign([], this.optionFields);

      //  When we change option,
      // We must cleared the last value of child options
      // if (i === 0 && Helper.isDefined(this.optionFields[i][j + 1])) {
      //   this.optionFields[i].splice(j + 1, 3);
      // }
      // this.convertFabricOptionToOption(this.optionFields);
      selectedOptions.forEach((local, localIndex) => {
        local.forEach((item, itemIndex) => {
          if (item.hasOwnProperty('AsFabricCollection')) {
            selectedOptions[localIndex][itemIndex].fabricCollection = item.optionSelected;
          }
          if (item.hasOwnProperty('AsFabric')) {
            selectedOptions[localIndex][itemIndex - 1].fabric = item.optionSelected;
          }
          if (item.hasOwnProperty('AsFabricColor')) {
            selectedOptions[localIndex][itemIndex - 2].fabricColor = item.optionSelected;
          }
        });
      });
      this.orderItemProductOption.emit({
        mainOption: selectedOptions,
        orderItem: orderItemIndex,
        formIsValid: this.optionForm.valid,
        show: false,
        firstParent: this.firstParent
      });

      /*
      // When this condition enable sub options of type select not show correctly
      if (Helper.isDefined(j)) {
        this.optionFields[i].splice(j + 2, this.optionFields[i].length);
        this.optionFields.splice(i + 1, this.optionFields.length);
      }*/
      // check if current option item has option child and option type is not select
      // then check if total child options of this option more than 0
      // check if first child options type not SELECT
      if (Helper.isDefined(optionItem.options) && optionItem.type !== Option.OPTION_TYPE_SELECT &&
        optionItem.options.length > 0 && optionItem.options[0].type == Option.OPTION_TYPE_OPTION) {
        if (optionItem.options.length > 0) {
          this.optionFields[i][1 + j] = {
            option: optionItem,
            children: optionItem.options,
            first: false,
            parent: optionItem.id,
            products: products,
            firstParent: this.firstParent
          };
        }
      }
      // Use this if for type fabric and its children
      else if (optionItem.type == Option.OPTION_TYPE_FABRIC && optionItem.fabricCollections.length > 0) {
        const selectedOptionsItem = Object.assign([], this.optionFields[parseInt(i) + 1]);
        const selectedOptionsItem2 = Object.assign([], this.optionFields[parseInt(i)]);
        if ((Helper.isDefined(selectedOptionsItem[0]) && !selectedOptionsItem[0].AsFabricCollection) || (Helper.isDefined(selectedOptionsItem[1]) && !selectedOptionsItem[1].AsFabricCollection) || selectedOptionsItem2[0]) {
          this.optionFields.splice(i + 1, 0, [{
            option: optionItem,
            children: optionItem.fabricCollections,
            first: false,
            parent: optionItem.id,
            AsFabricCollection: true,
            products: products,
            firstParent: this.firstParent,
            indentNumber: 0,
            status: optionItem.status,
            deleted: optionItem.deleted
          }]);
          this.optionFields[parseInt(i) + 1][0].indentNumber = (this.optionFields[parseInt(i)][0].indentNumber ? this.optionFields[parseInt(i)][0].indentNumber : 0) + 1;
          this.optionFields = JSON.parse(JSON.stringify(this.optionFields));
          this.options$.next(false);
          this.options$.next(true);
        }
        // this.indentNumber++;
      }
      // Use this if option type is fabric
      else if (!Helper.isDefined(optionItem.type) && Helper.isDefined(optionItem.fabrics) && optionItem.fabrics.length > 0) {
        const selectedOptionsx1 = Object.assign([], this.optionFields);
        // if (Helper.isDefined(this.optionFields[i][j + 2])) {
        //   this.optionFields[i].splice(j + 3, 1);
        // }
        //
        //
        this.optionFields[i][j + 1] = {
          option: optionItem,
          children: optionItem.fabrics,
          first: false,
          parent: optionItem.id,
          products: products,
          AsFabric: true,
          firstParent: this.firstParent,
          status: optionItem.status,
          deleted: optionItem.deleted
        };
        const selectedOptionsx2 = Object.assign([], this.optionFields);
      }
      // This if use for lastest fabric option loading
      else if (!Helper.isDefined(optionItem.type) && Helper.isDefined(optionItem.fabricColors) && optionItem.fabricColors.length > 0) {
        this.optionFields[i][j + 1] = {
          option: optionItem,
          children: optionItem.fabricColors,
          first: false,
          parent: optionItem.id,
          products: products,
          AsFabricColor: true,
          firstParent: this.firstParent,
          status: optionItem.status,
          deleted: optionItem.deleted
        };
      }
      // Other type of options
      else {
        if ((Helper.isDefined(optionItem.options) && optionItem.options.length > 0)) {
          for (let m = 0; m < optionItem.options.length; m++) {
            this.optionFields[i + 1 + m] = [{
              option: optionItem.options[m],
              children: (optionItem.options[m].options.length) ? optionItem.options[m].options : optionItem.options[m].fabricCollections,
              first: false,
              products: products,
              parent: optionItem.id,
              firstParent: this.firstParent,
              indentNumber: 0
            }];
            this.optionFields[i + 1 + m][0].indentNumber = this.optionFields[i + 1 + m][0].indentNumber + 1;
            this.optionFields = JSON.parse(JSON.stringify(this.optionFields));
            this.options$.next(false);
            this.options$.next(true);
            // we use this for
            if (m > 0) {
              this.indentNumber++;
            }
          }
          let chnageTemp = [];
          for (let i in this.optionFields) {
            chnageTemp.push((this.optionFields[i]));
          }
          this.optionFields = chnageTemp;

        }
        if (Helper.isDefined(optionItem.fabrics) && optionItem.fabrics.length > 0) {
          for (let m = 0; m < optionItem.fabrics.length; m++) {
            this.optionFields[i + 1 + m] = [{
              option: optionItem.fabrics[m],
              children: optionItem.fabrics[m].fabricColors,
              first: false,
              products: products,
              parent: optionItem.fabrics[m].id,
              firstParent: this.firstParent
            }];
          }
        }
      }
    }
  }

  /** D23: a carpet Shape/Finishing/Colour dropdown was cleared - notify the parent with the option removed */
  private emitOptionCleared(orderItemIndex): void {
    const clearedOptions = Object.assign([], this.optionFields);
    clearedOptions.forEach((local, localIndex) => {
      local.forEach((item, itemIndex) => {
        if (Object.hasOwn(item, 'AsFabricCollection')) {
          clearedOptions[localIndex][itemIndex].fabricCollection = item.optionSelected;
        }
        if (Object.hasOwn(item, 'AsFabric')) {
          clearedOptions[localIndex][itemIndex - 1].fabric = item.optionSelected;
        }
        if (Object.hasOwn(item, 'AsFabricColor')) {
          clearedOptions[localIndex][itemIndex - 2].fabricColor = item.optionSelected;
        }
      });
    });
    this.orderItemProductOption.emit({
      mainOption: clearedOptions,
      orderItem: orderItemIndex,
      formIsValid: this.optionForm.valid,
      show: false,
      firstParent: this.firstParent
    });
  }

  public getOption() {
    return Option;
  }

  isCarpetRoleOption(optionLocal): boolean {
    return Helper.isDefined(optionLocal?.option?.carpetRole);
  }

  canShowOption(field: any) {
    const optionLocal = field[0];
    return (!this.isEdit && !optionLocal.option.deleted && optionLocal.option.status) // if we are adding the order and option is not inactive or deleted
      || (this.isEdit && optionLocal['optionSelected']) // if option already has a value
      || (this.isEdit && !optionLocal.option.deleted && optionLocal.option.status); // if we are editing the order and option is not inactive or deleted
  }

  getPreparedChildItems(optionLocal, children, optionLocalSelectedItem) {
    if (this.isEdit || optionLocal.AsFabricCollection || optionLocal.AsFabric || optionLocal.AsFabricColor) {
      if (children && children.length > 0) {
        children.forEach(child => {
          if (child.status === false && !(Helper.isDefined(child.disabled))) {
            child.name += (' (' + this.translate.instant('global.inactive') + ')');
            child.disabled = true;
          }
          if (Helper.isDefined(child.disabled) && child.disabled && child.id !== optionLocalSelectedItem) {
            children = children.filter(item => item.id !== child.id);
          }
        });
      }
      if (optionLocalSelectedItem && optionLocal.option.status === false) {
        children = [
          children.find(({id}) => id === optionLocalSelectedItem)
        ];
      }
    }
    if (!this.isEdit) {
      children = children.filter(item => !item.deleted && item.status);
    }
    optionLocal.children = [...children];
  }

  checkIfAutoFocused(i, optionFields: any) {
    let result = (i >= 1);
    if (result && Helper.isDefined(optionFields[i])) {
      if (
        Helper.isDefined(optionFields[i][0].AsFabricCollection) && !Helper.isDefined(optionFields[i][0]['optionSelected'])
      ) {
        return true;
      }
      result = !Helper.isDefined(optionFields[i][0]['optionSelected']) &&
        (Helper.isDefined(optionFields[i - 1]) && Helper.isDefined(optionFields[i - 1][0]['optionSelected'])) &&
        !(Helper.isDefined(optionFields[i + 1]) && Helper.isDefined(optionFields[i + 1][0]['optionSelected']));
    }
    return result;
  }
}
